<template>
  <div :style="`width:${dispW}px;height:${dispH}px;padding-top:10px`">
    <!-- <div  @click="showQS" v-if="isQVisible" class="scan-quality" style="font-size: 27px; height: 60px;">
                <span>{{ $t('langcfg.txtScanQuality') }}:&nbsp;</span
                ><span :style="`color:${qsText.color};`">{{
                  qsText.label
                }}</span>
    </div> -->
    <div style="display: flex; flex-direction: column; align-items: center">
      <!-- <div @click="showQS" v-if="isQVisible"> -->
      <!-- <table style="width: 500px; height: 60px; font-size: 20px">
          <tr style="width: 500px">
            <td style="font-size: 27px"> -->
      <div @click="showQS" v-if="isQVisible" class="scan-quality">
        <span>{{ $t("langcfg.txtScanQuality") }}:&nbsp;</span
        ><span :style="`color:${qsText.color};`">{{ qsText.label }}</span>
      </div>
      <!-- </td>
          </tr>
        </table> -->
      <!-- </div> -->
      <img
        :style="imageStyle"
        v-if="rightsider.isImageBoolen"
        :src="url"
        @click="showLargeImg"
        alt
      />
    </div>
  </div>
</template>
<script>
import { FLATCOLOR, STEEPCOLOR } from "../shared/index";
import { TOPOGRAPHYEVENTS } from "../shared/events";
import { getCTCenterOffsetInfo } from "../js/CalCenter";
import fileSys from "../../fileoprators/fileSystem";
export default {
  name: "AxisIndication",
  data() {
    return {
      circle: {
        x: 205,
        y: 130,
        r: 65
      },
      image: undefined,
      showEdge: false,
      centOffset: { x: {}, y: {}, z: {} },
      qsHeight: 60
    };
  },
  mounted: function () {
    this.circle.x = this.dispW / 2;
    this.circle.y = this.dispH / 2;
    this.circle.r = (this.dispW > this.dispH ? this.dispH / 2 : this.dispW / 2) - 15;
    this.image = new Image();
    this.image.src = this.url;
  },
  props: {
    qs: {
      type: Array,
      default: () => []
    },
    isQVisible: false,
    dispW: {
      type: Number,
      default: 500 - 2
    },
    dispH: {
      type: Number,
      default: 480
    },
    axisFlat: {
      type: Number,
      default: 10
    },
    axisSteep: {
      type: Number,
      default: 90
    },
    rightsider: {
      type: Object,
      default: function () {
        return {
          isScaleBoolen: false,
          isImageBoolen: true
        };
      }
    },
    url: {
      type: String,
      default: ""
    },
    origImgPath: {
      type: String,
      default: ""
    }
  },
  watch: {
    showEdge: function (val) {
      this.$bus.$emit(TOPOGRAPHYEVENTS.showLargeImg, this.showEdge, true, this.centOffset);
    },
    origImgPath: function () {
      this.getCenterOffset();
    }
  },
  methods: {
    showLargeImg() {
      this.$bus.$emit(TOPOGRAPHYEVENTS.showLargeImg, this.showEdge, false, this.centOffset);
    },
    showQS() {
      this.$emit("show-qs");
    },
    getCenterOffset() {
      let originImgPath = this.origImgPath;
      if (fileSys.isFileExists(originImgPath)) {
        let caledInfo = getCTCenterOffsetInfo(originImgPath, 2048, 1536, 3);
        this.centOffset = caledInfo.offsetstr;
      } else {
        this.centOffset = { x: {}, y: {}, z: {} };
      }
    }
  },
  computed: {
    qsText() {
      if (this.qs)
        return {
          color: this.qs[this.qs.length - 1].color,
          label: this.$t(`langcfg.${this.qs[this.qs.length - 1].label}`)
        };
      else return { color: "white", label: "--" };
    },
    flatColor() {
      return FLATCOLOR;
    },
    steepColor() {
      return STEEPCOLOR;
    },
    imageStyle() {
      if (this.image) {
        let imgW = 2048;
        let imgH = 1536;
        let wRatio = this.dispW / imgW;
        let hRatio = (this.dispH - 25) / imgH;
        let w, h;
        if (wRatio < hRatio) {
          w = this.dispW;
          h = imgH * wRatio;
        } else {
          h = this.dispH - 25;
          w = imgW * hRatio;
        }
        let style = {
          position: "relative",
          width: `${w}px`,
          height: `${h}px`,
          "margin-left": `${this.dispW / 2 - w / 2}px`,
          "margin-top": `${(this.dispH - 25) / 2 - h / 2}px`
        };
        return style;
      } else {
        return {};
      }
    }
  }
};
</script>
<style lang="less" scoped>
.input-checkbox {
  padding: 0px;
  border: none;
  width: 20px;
  height: 20px;
  margin-right: 0px;
}
.div-fail {
  position: absolute;
  line-height: 50px;
  padding: 5px;
  font-size: 30px;
  color: red;
  text-align: left;
  top: 30px;
}
.scan-quality {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 27px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/AxisIndication.vue